'use client';

import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next, useTranslation } from 'react-i18next';

import { getOptions, languages } from './settings';

const isServerSide = typeof window === 'undefined';

i18n
  .use(initReactI18next)
  .use(resourcesToBackend((language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)))
  .init({
    ...getOptions(),
    preload: isServerSide ? languages : [],
  });

export { i18n, useTranslation };
